import script from "./AlertMobile.vue?vue&type=script&lang=js"
export * from "./AlertMobile.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__